module.exports = __webpack_public_path__ + "img/vaxrx-logo.8e2beeb9.png";